<template>
  <div class="detail-view-content-area">
    <div v-if="isVod" class="preview-detail-box">
      <strong class="preview-title">
        {{ season.title }}
      </strong>
      <em class="preview-subtitle">
        현재 에피소드 :
        <template v-if="episode.number">
          {{ episode.number }}
        </template>
        <template v-if="episode.number && episode.title">. </template>
        <template v-if="episode.title">
          <span v-html="episode.title" />
        </template>
      </em>
      <p class="preview-dsc" v-html="episode.synopsis" />
      <div v-if="hasActorList" class="content-actor-box">
        <strong>출연 :</strong>
        <template v-for="(actor, index) in actorList">
          <span :key="`actors_${index}`" class="content-actor-list">
            <a href="javascript:void(0)" @click.prevent="searchText(actor)">
              {{ actor.text }}
            </a>
          </span>
          <template v-if="index !== actorList.length - 1">, </template>
        </template>
      </div>
    </div>

    <div class="detail-view-box">
      <div class="thumb-box">
        <template v-if="posterImage">
          <div class="picture-area">
            <WebpImage
              :image-info="{
                imageUrl: posterImage,
                width: 240,
                height: 360,
                alt: season.title,
                className: 'thumb-img',
                onImageLoad,
              }"
            />
          </div>
        </template>
        <template v-else>
          <div class="no-thumb" :aria-hidden="!isImageLoaded">
            <span class="alt-text">{{ season.title }}</span>
          </div>
        </template>
      </div>

      <div class="detail-info-box">
        <em v-if="!isVod" class="preview-subtitle">{{ title }}</em>
        <p class="detail-dsc" v-html="synopsis" />
        <table class="detail-info-table">
          <colgroup>
            <col style="width: 76px" />
            <col style="width: auto" />
          </colgroup>
          <tr>
            <th scope="row">개요</th>
            <td>{{ summary }}</td>
          </tr>
          <template v-for="(tableItem, index) in tableList">
            <TableRow
              v-if="tableItem.show"
              :th="tableItem.title"
              :td="tableItem"
              @click-fn="tableItem.click"
              :key="`${tableItem.title}_${index}`"
            />
          </template>
          <tr>
            <th scope="row">등급</th>
            <td>
              <AgeGrade
                :target-age="targetAge"
                :section="kmrbCode"
                :size="50"
              />
            </td>
          </tr>
          <tr v-if="hasKmrbCode && hasGradeInfo">
            <th scope="row">내용정보</th>
            <td><GradeInfo :grade-info="gradeInfo" /></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    PATH_NAME_SEARCH,
    PATH_NAME_SEARCH_TAG_GROUP,
  } from '@/common/resources/router.const'
  import PlayerDetailInfoMixin from '@/mixins/player.detail.info.mixin'
  import TableRow from '@/components/player/TableRowContent'
  import AgeGrade from '@/components/player/AgeGrade'
  import GradeInfo from '@/components/player/GradeInfo'
  import WebpImage from '@/components/image/WebpImage'

  export default {
    name: 'ContentsDetail',
    components: {
      WebpImage,
      AgeGrade,
      GradeInfo,
      TableRow,
    },
    mixins: [PlayerDetailInfoMixin],
    props: {
      contentInfo: {
        type: Object,
        default: () => ({}),
      },
      section: {
        type: String,
        default: 'vod', // vod / movie
      },
    },
    data() {
      return {
        isImageLoaded: false,
      }
    },
    computed: {
      episode() {
        const {
          episodenumber: episodeNumber = '',
          episodetitle: title = '',
          episodesynopsis: synopsis = '',
        } = this.contentInfo
        const number = episodeNumber.replace('회', '')

        return { number, title, synopsis }
      },
      gradeInfo() {
        return this.contentInfo?.gradeinfo || {}
      },
      kmrbCode() {
        const { kmrbcode = '' } = this.contentInfo
        return kmrbcode ? 'movie' : 'vod'
      },
      posterImage() {
        const {
          image = '',
          moviegroupimage = '',
          moviegrouptitlelogoimage = '',
        } = this.contentInfo
        if (this.isVod) {
          return this.season.posterImage
        } else {
          return (image || moviegroupimage || moviegrouptitlelogoimage)
            .replace('https://', '')
            .replace('http://', '')
        }
      },
      season() {
        const {
          seasontitle: title = '',
          seasonsynopsis: synopsis = '',
          seasonposterimage = '',
        } = this.contentInfo
        const posterImage = seasonposterimage

        return { title, synopsis, posterImage }
      },
      summary() {
        const {
          channelname = '',
          releasedate = '',
          nation: vodCountry = '',
          country: movieCountry = '',
          releaseyear = '',
        } = this.contentInfo
        const country = this.isVod ? vodCountry : movieCountry
        const movieYear = releasedate ? `${releasedate.substring(0, 4)}년` : ''
        const yearInfo = this.section === 'vod' ? releaseyear : movieYear
        return [channelname, country, yearInfo]
          .filter((infoText) => infoText !== '')
          .join(', ')
      },
      synopsis() {
        const { synopsis = '' } = this.contentInfo
        return this.isVod ? this.season.synopsis : synopsis
      },
      targetAge() {
        return (
          this.contentInfo?.seasontargetage || this.contentInfo?.targetage || ''
        )
      },
      title() {
        const { title = '' } = this.contentInfo
        return this.isVod ? this.episode.title : title
      },
      isVod() {
        return this.section === 'vod'
      },
      hasKmrbCode() {
        const { kmrbcode = '' } = this.contentInfo
        return kmrbcode.length > 0
      },
      hasGradeInfo() {
        return Object.values(this.gradeInfo).indexOf('') <= -1
      },
      tableList() {
        const vod = [
          {
            title: '장르',
            list: this.tagList,
            click: this.tagSearchUrl,
            show: this.hasTagList,
          },
          {
            title: '출연',
            list: this.seasonActorList,
            click: this.searchText,
            show: this.hasSeasonActorList,
          },
          {
            title: '감독',
            list: this.seasonDirectorList,
            click: this.searchText,
            show: this.hasSeasonDirectorList,
          },
          {
            title: '작가',
            list: this.seasonWriterList,
            click: this.searchText,
            show: this.hasSeasonWriterList,
          },
        ]
        const movie = [
          {
            title: '장르',
            list: this.tagList,
            click: this.tagSearchUrl,
            show: this.hasTagList,
          },
          {
            title: '출연',
            list: this.actorList,
            click: this.searchText,
            show: this.hasActorList,
          },
          {
            title: '감독',
            list: this.directorList,
            click: this.searchText,
            show: this.hasDirectorList,
          },
        ]
        return this.isVod ? vod : movie
      },
    },
    methods: {
      searchText(searchWord) {
        this.$router.push({
          name: PATH_NAME_SEARCH,
          query: {
            searchWord: searchWord.value,
          },
        })
      },
      tagSearchUrl(tag) {
        const { contentid = '', movieid = '' } = this.contentInfo
        this.$router.push({
          name: PATH_NAME_SEARCH_TAG_GROUP,
          query: {
            tag: tag.value,
            text: tag.text,
            list: this.section,
            contentid: this.isVod ? contentid : movieid,
          },
        })
      },
      onImageLoad() {
        this.isImageLoaded = true
      },
    },
  }
</script>
